// AUTOGENERATED — do not edit. Run `bun run codegen/generate.ts` to regenerate.
// Re-exports every generated mode schema.

import type { ModeSchema } from './types';
import { BreakorSchema } from './breakor_schema';
import { ChannelStripSchema } from './channel_strip_schema';
import { ElysiamorfSchema } from './elysiamorf_schema';
import { MemlceliumSchema } from './memlcelium_schema';
import { PafSynthSchema } from './paf_synth_schema';
import { SlpWorkshopSchema } from './slp_workshop_schema';
import { SoundAnalysisMidiSchema } from './sound_analysis_midi_schema';
import { VerbFxSchema } from './verb_fx_schema';
import { XiasriSchema } from './xiasri_schema';

export * from './types';
export * from './breakor_schema';
export * from './channel_strip_schema';
export * from './elysiamorf_schema';
export * from './memlcelium_schema';
export * from './paf_synth_schema';
export * from './slp_workshop_schema';
export * from './sound_analysis_midi_schema';
export * from './verb_fx_schema';
export * from './xiasri_schema';

/** Every generated mode schema, mode_id-sorted. Mechanically-derived mode-identity truth. */
export const ALL_MODE_SCHEMAS: readonly ModeSchema[] = [
  BreakorSchema,
  ChannelStripSchema,
  ElysiamorfSchema,
  MemlceliumSchema,
  PafSynthSchema,
  SlpWorkshopSchema,
  SoundAnalysisMidiSchema,
  VerbFxSchema,
  XiasriSchema,
];
